import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import VueAnalytics from 'vue-analytics'

Vue.use(Router)


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:initialSyntax?',
      name: 'home',
      component: Home,
      props: true
    }
  ]
})

Vue.use(VueAnalytics, {
  id: 'UA-129826653-2',
  router,
  autoTracking: {
    screenview: true
  }
})

export default router
